import { SvgProps } from '..';

export const WebsiteIcon: React.FC<React.PropsWithChildren<SvgProps>> = (
  props
) => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath={`url(#${props.id}_website_clip0)`}>
        <path
          d="M13.5907 6.08534C12.8873 2.73517 11.3872 0.615672 9.99982 0.615672C8.61242 0.615672 7.11234 2.73517 6.40897 6.08534H13.5907Z"
          fill="white"
        />
        <path
          d="M5.99963 10.1876C5.99946 11.1022 6.05893 12.0159 6.17764 12.9224H13.822C13.9407 12.0159 14.0002 11.1022 14 10.1876C14.0002 9.27293 13.9407 8.35928 13.822 7.45275H6.17764C6.05893 8.35928 5.99946 9.27293 5.99963 10.1876Z"
          fill="white"
        />
        <path
          d="M6.40897 14.2898C7.11234 17.64 8.61242 19.7595 9.99982 19.7595C11.3872 19.7595 12.8873 17.64 13.5907 14.2898H6.40897Z"
          fill="white"
        />
        <path
          d="M14.9561 6.08517H19.1563C18.5252 4.6123 17.5663 3.3116 16.3565 2.2874C15.1467 1.2632 13.7197 0.544003 12.1899 0.1875C13.4547 1.32861 14.4467 3.43853 14.9561 6.08517Z"
          fill="white"
        />
        <path
          d="M19.6357 7.45275H15.1688C15.2788 8.35999 15.3338 9.27336 15.3335 10.1876C15.3335 11.1018 15.2783 12.0152 15.1681 12.9224H19.635C20.1212 11.1333 20.1219 9.24189 19.6357 7.45275Z"
          fill="white"
        />
        <path
          d="M12.1899 20.1875C13.72 19.8312 15.1472 19.1121 16.3573 18.0879C17.5673 17.0637 18.5264 15.7629 19.1576 14.2898H14.9574C14.4467 16.9365 13.4547 19.0464 12.1899 20.1875Z"
          fill="white"
        />
        <path
          d="M5.04359 14.2898H0.843376C1.4746 15.7629 2.43371 17.0637 3.64374 18.0879C4.85378 19.1121 6.28106 19.8312 7.81107 20.1875C6.545 19.0464 5.55295 16.9365 5.04359 14.2898Z"
          fill="white"
        />
        <path
          d="M7.80971 0.1875C6.2797 0.54381 4.85242 1.26292 3.64239 2.28713C2.43235 3.31134 1.47325 4.61214 0.842022 6.08517H5.04224C5.55293 3.43853 6.54498 1.32861 7.80971 0.1875Z"
          fill="white"
        />
        <path
          d="M4.6662 10.1876C4.66612 9.27335 4.72134 8.35998 4.83154 7.45275H0.364653C-0.121551 9.24189 -0.121551 11.1333 0.364653 12.9224H4.83154C4.72134 12.0152 4.66612 11.1018 4.6662 10.1876Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id={`#${props.id}_website_clip0`}>
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0 0.1875)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
